import FormData from 'form-data';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const convertToFormData = (object: NonNullable<any>) => {
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    if (typeof object[key] !== 'object') formData.append(key, `${object[key]}`);
    else formData.append(key, `${JSON.stringify(object[key])}`);
  });
  return formData;
};

export default convertToFormData;
